import React, { Component } from "react";
import {
  Route,
  BrowserRouter
} from "react-router-dom";
import Home from "./components/Home";

import Software from "./components/Software";
import Blog from "./components/Blog";
import Nav from "./components/Nav";

class AppRoute extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
            <Nav />
            <Route exact path="/" component={Home} />
            <Route path="/blog" component={Blog} />
            <Route path="/software" component={Software} />
        </div>
      </BrowserRouter>
    );
  }
}

export default AppRoute;



// WEBPACK FOOTER //
// ./src/routes.js